import React from "react";
import { Tag, Gift, HandCoins, Handshake } from "lucide-react";

export const PRICE_TYPES = [
  { value: "fixed", label: "PEVNÁ CENA", icon: Tag, hint: "Zadej částku v Kč" },
  { value: "free", label: "ZDARMA", icon: Gift, hint: "Inzerát se zobrazí jako ZDARMA" },
  { value: "negotiable", label: "DOHODOU", icon: Handshake, hint: "Cenu si domluvíš s kupujícím" },
  { value: "offer", label: "NABÍDNĚTE CENU", icon: HandCoins, hint: "Cenu navrhne kupující" },
];

export default function PriceTypePicker({ value, onChange, testIdPrefix = "price-type" }) {
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2" role="radiogroup" aria-label="Typ ceny">
        {PRICE_TYPES.map((t) => {
          const Icon = t.icon;
          const active = value === t.value;
          return (
            <button
              key={t.value}
              type="button"
              onClick={() => onChange(t.value)}
              role="radio"
              aria-checked={active}
              className={`stb-segment ${active ? "stb-segment-active" : ""}`}
              data-testid={`${testIdPrefix}-${t.value}`}
            >
              <Icon size={16} />
              <span>{t.label}</span>
            </button>
          );
        })}
      </div>
      <p className="stb-mono text-xs text-[#A3A3A3] mt-1">
        {PRICE_TYPES.find((t) => t.value === value)?.hint || ""}
      </p>
    </div>
  );
}
